var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#464a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "465b",
    width: 29,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.125 0H2.75C1.231 0 0 .955 0 2.133v11.734C0 15.045 1.231 16 2.75 16h23.375c1.519 0 2.75-.955 2.75-2.133V2.133C28.875.955 27.644 0 26.125 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#465b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE200",
    fillRule: "evenodd",
    d: "M0 0h11v16H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11 0h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    d: "m13.75 6.398 4.125 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ED9069",
    d: "M15.813 8v2.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF9E00",
    fillRule: "evenodd",
    d: "M13.75 6.399h4.125l-2.062-2.133z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CF9E00",
    d: "m17.875 6.398-4.125 3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.25.535H2.75c-1.14 0-2.062.717-2.062 1.6V13.87c0 .883.923 1.6 2.062 1.6h16.5c1.14 0 2.063-.717 2.063-1.6V2.134c0-.883-.924-1.6-2.063-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "464a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagVa = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagVa);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzYyMjlfNzI0NjQpIj4KPG1hc2sgaWQ9Im1hc2swXzYyMjlfNzI0NjQiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyOSIgaGVpZ2h0PSIxNiI+CjxwYXRoIGQ9Ik0yNi4xMjUgMEgyLjc1QzEuMjMxMjIgMCAwIDAuOTU1MTI2IDAgMi4xMzMzM1YxMy44NjY3QzAgMTUuMDQ0OSAxLjIzMTIyIDE2IDIuNzUgMTZIMjYuMTI1QzI3LjY0MzggMTYgMjguODc1IDE1LjA0NDkgMjguODc1IDEzLjg2NjdWMi4xMzMzM0MyOC44NzUgMC45NTUxMjYgMjcuNjQzOCAwIDI2LjEyNSAwWiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzYyMjlfNzI0NjQpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDBIMTFWMTZIMFYwWiIgZmlsbD0iI0ZGRTIwMCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExIDBIMjBDMjEuMTA0NiAwIDIyIDAuODk1NDMxIDIyIDJWMTRDMjIgMTUuMTA0NiAyMS4xMDQ2IDE2IDIwIDE2SDExVjBaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTMuNzUgNi4zOTg0NEwxNy44NzUgOS41OTg0NCIgc3Ryb2tlPSIjQ0NDQ0NDIi8+CjxwYXRoIGQ9Ik0xNS44MTI1IDhWMTAuNjY2NyIgc3Ryb2tlPSIjRUQ5MDY5Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNzUgNi4zOTg5NkgxNy44NzVMMTUuODEyNSA0LjI2NTYyTDEzLjc1IDYuMzk4OTZaIiBmaWxsPSIjQ0Y5RTAwIi8+CjxwYXRoIGQ9Ik0xNy44NzUgNi4zOTg0NEwxMy43NSA5LjU5ODQ0IiBzdHJva2U9IiNDRjlFMDAiLz4KPHBhdGggZD0iTTE5LjI1IDAuNTM1MTU2SDIuNzVDMS42MTA5MSAwLjUzNTE1NiAwLjY4NzUgMS4yNTE1IDAuNjg3NSAyLjEzNTE2VjEzLjg2ODVDMC42ODc1IDE0Ljc1MjEgMS42MTA5MSAxNS40Njg1IDIuNzUgMTUuNDY4NUgxOS4yNUMyMC4zODkxIDE1LjQ2ODUgMjEuMzEyNSAxNC43NTIxIDIxLjMxMjUgMTMuODY4NVYyLjEzNTE2QzIxLjMxMjUgMS4yNTE1IDIwLjM4OTEgMC41MzUxNTYgMTkuMjUgMC41MzUxNTZaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF82MjI5XzcyNDY0Ij4KPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";